import React, { Component } from 'react'
import { Dispatch } from 'react-redux'
import { getAlumniCategoryByType, toggleAlumniCategory } from '~/services/api'
import { ClassDTO } from '~/model'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import * as Status from '~/helper/constant/status'
import * as route from '~/helper/constant/route'
import { toastMessage } from '~/helper/function/util'
import moment from 'moment'
import $ from 'jquery'
import * as ALUMNI_CATEGORY from '~/helper/constant/alumni_category'

type Props = {
    token: String,
    dispatch: Dispatch<any>,
}

type State = {
    classes: Array,
    data: Array,
    loading: Boolean,
}

export class AbstractAlumniCategoryViewComponent extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        const { t } = this.props
        this.state = {
            loading: false,
            pageTitle: this.props.match.params.type != null ? ALUMNI_CATEGORY.categoryList.find((item) => item.value == this.props.match.params.type) : null,
            data: [],
            alumni_category: [
                {
                    name: {
                        field: 'text',
                        translate: 'name',
                        route: false,
                        sortable: true,
                    },
                    code: {
                        field: 'text',
                        translate: 'classes:class.codeLabel',
                        route: false,
                        sortable: true,
                    },
                    status: {
                        field: 'badge',
                        translate: 'status',
                        route: false,
                        sortable: true,
                    },
                    action: {
                        field: 'button',
                        translate: 'classes:class.action',
                        route: true,
                        sortable: false,
                    },
                },
            ],
        }
        this._handleChange = this._handleChange.bind(this)
        this.toggle = this.toggle.bind(this)
    }

    componentDidUpdate(prevProps) {
        const { t } = this.props
        if (this.props.match.params.type != prevProps.match.params.type) {
            this.setState(
                {
                    pageTitle: this.props.match.params.type != null ? ALUMNI_CATEGORY.categoryList.find((item) => item.value == this.props.match.params.type) : null,
                },
                () => {
                    this.loadAlumniCategory()
                }
            )
        }
    }

    componentDidMount() {
        this.loadAlumniCategory()
    }

    _handleChange(key, data) {
        this.setState({ [key]: data })
    }

    toggle(e) {
        const link = e.target.getAttribute('link')
        $('#close_' + link).trigger('click')
        toggleAlumniCategory(link, this.props.token).then((response) => {
            if (response.code == API_SUCCESS) {
                toastMessage('success', response.message)
                this.loadAlumniCategory()
            } else {
                toastMessage('error', response.message)
            }
        })
    }

    loadAlumniCategory() {
        this._handleChange('loading', true)
        getAlumniCategoryByType(this.props.match.params.type, this.props.token).then((response) => {
            this._handleChange('loading', false)
            let alumni_category = []
            alumni_category.push(this.state.alumni_category[0])
            let dataList = []
            if (response.code == API_SUCCESS) {
                response.data.alumni_category.map((item, index) => {
                    const data = item
                    let text = null
                    if (data.status == Status.ACTIVE) {
                        text = {
                            text: 'Active',
                            translate: 'statusActive',
                            badge: 'table-green',
                            modal: 'modal_alumni_category_' + index,
                        }
                    } else {
                        text = {
                            text: 'Inactive',
                            translate: 'statusInactive',
                            badge: 'table-red',
                            modal: 'modal_alumni_category_' + index,
                        }
                    }
                    const tableData = {
                        name: {
                            text: data.name,
                        },
                        code: {
                            text: data.code,
                        },
                        status: text,
                        action: {
                            text: 'Edit',
                            translate: 'EditBtn',
                            route: route.admin.alumni.category.edit + '/' + this.props.match.params.type + '/' + data.id,
                        },
                    }
                    dataList.push(data)
                    alumni_category.push(tableData)
                })
            }
            this.setState({
                data: dataList,
                alumni_category,
            })
        })
    }
}

export function mapStateToProps(state: Object) {
    return {
        token: state.token,
    }
}
